import GetServer from "../Components/Panel/GetServer";
import Layout from "./Layout";

export default function Serverconfig() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 w-full my-6">
        <GetServer />
      </section>
    </Layout>
  );
}
